import moment from 'moment'
import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'
import getFieldFromItem, { fieldLang, getFieldWithLangKey, getNewObjFromDirtyLangObj } from '../utils/getFieldFromItem'

export const keys = []

export const editForm = formFieldsChange => ({
  type: ActionTypes.CV_EDUCATIONFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.CV_EDUCATIONFORM_ENTER_RESET,
})

export const fetchItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_EDUCATIONFORM_FETCHITEM_LOAD })
  try {
    let item = await api.get(`cv_educations/${params.id}`)
    item = {
      ...item,
      ...getFieldWithLangKey({
        fieldTitle: 'data', objString: item.data, languages: fieldLang,
      }),
      fromYear: moment(item.fromYear),
      toYear: moment(item.toYear),
    }
    dispatch({
      type: ActionTypes.CV_EDUCATIONFORM_FETCHITEM_SUCCEED,
      item,
    })
    const field = getFieldFromItem(item)
    dispatch({
      type: ActionTypes.CV_EDUCATIONFORM_EDITFORM_CHANGE,
      field,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_EDUCATIONFORM_FETCHITEM_FAIL,
      fetchItemError: error.message,
    })
  }
}

export const createItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_EDUCATIONFORM_CREATEITEM_LOAD })
  try {
    await api.create(`cv_educations`, {
      ...getNewObjFromDirtyLangObj({ fieldTitle: 'data', languages: fieldLang, obj: params }),
      fromYear: params.fromYear? moment(params.fromYear).format('YYYY-MM-DD'): null,
      toYear:   params.toYear?   moment(params.toYear).format('YYYY-MM-DD')  : null,
    })
    dispatch({ type: ActionTypes.CV_EDUCATIONLIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.CV_EDUCATIONFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_EDUCATIONFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_EDUCATIONFORM_CREATEITEM_FAIL,
      createItemError: error.message,
    })
  }
}

export const editItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_EDUCATIONFORM_EDITITEM_LOAD })
  try {
    await api.patch(`cv_educations/${params.id}`, {
      ...getNewObjFromDirtyLangObj({ fieldTitle: 'data', languages: fieldLang, obj: params }),
      fromYear: params.fromYear? moment(params.fromYear).format('YYYY-MM-DD'): null,
      toYear:   params.toYear?   moment(params.toYear).format('YYYY-MM-DD')  : null,
    })
    dispatch({ type: ActionTypes.CV_EDUCATIONFORM_EDITITEM_SUCCEED })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_EDUCATIONFORM_EDITITEM_FAIL,
      editItemError: error.message,
    })
  }
}

export const deleteItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_EDUCATIONFORM_DELETEITEM_LOAD })
  try {
    await api.delete(`cv_educations/${params.id}`)
    dispatch({ type: ActionTypes.CV_EDUCATIONFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_EDUCATIONFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_EDUCATIONFORM_DELETEITEM_FAIL,
      deleteItemError: error.message,
    })
  }
}
